import React, {Fragment, useContext, useEffect, useState} from 'react';
import {
    Button,
} from '@material-ui/core';
import {Formik, Form} from 'formik';

import InformacionForm from './Forms/InformacionForm';
import CoberturasForm from './Forms/CoberturasForm';

import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';
import {useAuth0} from "@auth0/auth0-react";

import axios from 'axios';
import white_house_icon from "../../../../../assets/images/white_house_icon.png";
import ProgressBar from "../../../../customer/ProductsCustomer/ProgressBar";
import CotizarContext from "../../../../../context/CotizarContext";
import IndicatorsContext from "../../../../../context/AdviserContext/IndicatorsContext";
import moment from "moment";

const steps = ['Información', 'Coberturas'];
const {formId, formField} = formModel;

function assignSumaAseguradaBasedOnTamanioVivienda(numeroCobertura, tamanioVivienda, coberturasInformation) {
    const coberturaInfoFound = coberturasInformation.find((obj) => obj['NumeroCobertura'] === numeroCobertura);
    switch (tamanioVivienda) {
        case 'Chica':
            return coberturaInfoFound['SumaChica'];
        case 'Mediana':
            return coberturaInfoFound['SumaMediana'];
        case 'Grande':
            return coberturaInfoFound['SumaGrande'];
    }
}

function adjustInitialCoberturas(coberturasBase, coberturasReceived, tamanioVivienda, coberturasInformation) {
    for (const cobertura of coberturasBase) {
        const numeroCobertura = cobertura.numeroCobertura;
        const objetoCobertura = coberturasReceived.find((obj) => obj.numeroCobertura === numeroCobertura);

        if (objetoCobertura) {
            cobertura.sumaAsegurada = objetoCobertura.sumaAsegurada;
        } else {
            cobertura.selectedCobertura = false;
            cobertura.sumaAsegurada = assignSumaAseguradaBasedOnTamanioVivienda(
                numeroCobertura,
                tamanioVivienda,
                coberturasInformation
            )
        }
    }

    return coberturasBase;
}

function _renderStepContent(step, cotizacionRetomada, errors) {
    switch (step) {
        case 0:
            return <InformacionForm formField={formField}/>;
        case 1:
            return <CoberturasForm formField={formField} cotizacionRetomada={cotizacionRetomada} errors={errors}/>;
        default:
            return <div>Not Found</div>;
    }
}

export default function CheckoutPage(props) {
    const cotizacionRetomada = props.cotizacionRetomada; //Indicates if it's a new quote or it isn't
    const nuevoFormInitialValues = props.cotizacionValues;
    const action = props.action;
    const handlerEndCotizacion = props.handlerEndCotizacion;
    const setIsCotizarDone = props.setIsCotizarDone;
    const setIsCotizando = props.setIsCotizando;
    const [isCotizarDone2, setIsCotizarDone2] = useState(false);
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(action === 'emitir' ? steps.length : 0);
    const currentValidationSchema = validationSchema[activeStep];
    const [cotizacionResponse, setCotizacionResponse] = useState(null);
    const [finalValues, setFinalValues] = useState(null);
    const {getIdTokenClaims} = useAuth0();
    const {afinidadesPic, coberturasInfo} = useContext(CotizarContext)
    const {handleModified} = useContext(IndicatorsContext)

    const [saved, setSaved] = useState(false)

    const numerosCoberturasAdicionales = ["26", "36", "37", "48", "49"];
    let cobAdicionales = [
        {
            ["sumaAsegurada"]: "10000",
            ["numeroCobertura"]: "26",
            ["selectedCoberturaAdicional"]: false
        },
        {
            ["sumaAsegurada"]: "10000",
            ["numeroCobertura"]: "36",
            ["selectedCoberturaAdicional"]: false
        },
        {
            ["sumaAsegurada"]: "1000",
            ["numeroCobertura"]: "37",
            ["selectedCoberturaAdicional"]: false
        },
        {
            ["sumaAsegurada"]: "0",
            ["numeroCobertura"]: "48",
            ["selectedCoberturaAdicional"]: false
        },
        {
            ["sumaAsegurada"]: "0",
            ["numeroCobertura"]: "49",
            ["selectedCoberturaAdicional"]: false
        },
    ];

    let nuevoInitialValues;
    if (cotizacionRetomada) {
        nuevoFormInitialValues.coberturas.map((cobertura) => {
            if (numerosCoberturasAdicionales.includes(cobertura.numeroCobertura)) {
                for (let cobAdt of cobAdicionales) {
                    if (cobAdt.numeroCobertura === cobertura.numeroCobertura) {
                        cobAdt.selectedCoberturaAdicional = true;
                        cobAdt.sumaAsegurada = cobertura.sumaAsegurada
                    } else {
                        cobAdt.sumaAsegurada = assignSumaAseguradaBasedOnTamanioVivienda(
                            cobAdt.numeroCobertura,
                            nuevoFormInitialValues['TamanioVivienda'],
                            coberturasInfo
                        )
                    }
                }
            } else {
                for (let cobAdt of cobAdicionales) {
                    cobAdt.sumaAsegurada = assignSumaAseguradaBasedOnTamanioVivienda(
                        cobAdt.numeroCobertura,
                        nuevoFormInitialValues['TamanioVivienda'],
                        coberturasInfo
                    )
                }
            }
        })

        //Todo: remove filter. It's a temporal solution to already saved quotations that includes cobertura "38"
        let coberturasInitial = nuevoFormInitialValues.coberturas.filter((cob) => cob.numeroCobertura !== "38")
        //This is a necessary filter to remove coberturas that are going to be included later
        coberturasInitial = coberturasInitial.filter(cob => !numerosCoberturasAdicionales.includes(cob.numeroCobertura))

        //Si la fecha de hoy es despues de la fecha cotización
        if (moment(moment().format('YYYY-MM-DD')).isAfter(nuevoFormInitialValues['FechaCotizacion']))
            nuevoFormInitialValues['FechaCotizacion'] = moment().format('YYYY-MM-DD');

        nuevoInitialValues = {
            'afinidad': nuevoFormInitialValues.idAfinidad.toString(),
            'tamanioVivienda': nuevoFormInitialValues.TamanioVivienda,
            'tipoVivienda': nuevoFormInitialValues.TipoVivienda,
            "codigosLocalidad": nuevoFormInitialValues.CodigosLocalidad,
            "descuentoEspecial": nuevoFormInitialValues.DescuentoEspecial,
            "deducible": nuevoFormInitialValues.Deducible.toString(),
            "coberturas": adjustInitialCoberturas(formInitialValues.coberturas, coberturasInitial, nuevoFormInitialValues.TamanioVivienda, coberturasInfo),
            "coberturasAdicionales": cobAdicionales,
            "fechaCotizacion": nuevoFormInitialValues['FechaCotizacion'],
            //This is only gonna be sended when it's a "recotizacion"
            "id": nuevoFormInitialValues.id,
        }

        if (nuevoFormInitialValues.Clientes !== null) {
            nuevoInitialValues = {
                ...nuevoInitialValues,
                "nombre": nuevoFormInitialValues.Clientes.Nombre,
                "apellido": nuevoFormInitialValues.Clientes.Apellido,
                "email": nuevoFormInitialValues.Clientes.Email,
                "dni": nuevoFormInitialValues.Clientes.DNI,
                "codigoArea": nuevoFormInitialValues.Clientes.CodArea,
                "telefono": nuevoFormInitialValues.Clientes.Telefono,
                "idCliente": nuevoFormInitialValues.idCliente
            }
        }

    }

    async function _submitForm(values, actions) {
        setIsCotizarDone2(false)
        setIsCotizando(true)
        setIsCotizarDone(false)
        if (action !== 'emitir')
            actions.setSubmitting(true)

        const claims = await getIdTokenClaims();
        const id_token = claims.__raw;

        let coberturasFinal = []

        let url = process.env.REACT_APP_BACK_SERVER + '/cotizar/combinado';

        values.origen = 'affinity';
        values.descuentoEspecial = 20;
        values.deducible = parseInt(values.deducible);
        afinidadesPic.map(af => {
            if (af.id === values.afinidad) {
                values.img_afinidad = af.pic;
            }
        })

        if (saved || values.id > 0) {
            values.is_saved = true
        }

        for (let adVal of values.coberturasAdicionales) {
            if (adVal.selectedCoberturaAdicional === true) {
                coberturasFinal.push({
                    sumaAsegurada: adVal.sumaAsegurada,
                    numeroCobertura: adVal.numeroCobertura
                });
            }
        }

        values.coberturas.map(cob => {
            if (cob.selectedCobertura) {
                coberturasFinal.push({
                    sumaAsegurada: cob.sumaAsegurada,
                    numeroCobertura: cob.numeroCobertura
                });
            }
        })

        // Adding a new object to the array of coberturas with the values of the cobertura 38.
        let _RC5 = coberturasFinal.find(cobertura => cobertura.numeroCobertura === '5')
        coberturasFinal.push({sumaAsegurada: _RC5.sumaAsegurada, numeroCobertura: '38'})

        const jsonData = {
            ...values,
            "coberturas": coberturasFinal
        }

        setFinalValues(jsonData);

        axios.post(url, {...jsonData, ...{saveToDatabase: true}}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${id_token}`,
            }
        }).then(res => {
            // res.data.idCotizacion = res.data.cotizacionId
            setCotizacionResponse(res.data);
            setIsCotizarDone2(true)
            values.id = res.data.cotizacionId
            setSaved(true)
            if (action !== 'emitir')
                actions.setSubmitting(false);
            if (!values.is_saved)
                handleModified()
        }).catch(err => {
            if (action !== 'emitir')
                actions.setSubmitting(false);
            alert(err)
        });
        if (activeStep === 0) {
            setActiveStep(activeStep + 1);
        }
    }


    function _handleSubmit(values, actions) {
        if (activeStep > 0) {
            _submitForm(values, actions);
        } else {
            setActiveStep(activeStep + 1);
            actions.setTouched({});
            actions.setSubmitting(false);
        }
    }

    function _handleBack() {
        setActiveStep(activeStep - 1);
        setIsCotizando(false)
    }

    useEffect(() => {
        if (action === 'emitir') {
            setFinalValues(nuevoInitialValues)
            if (activeStep === steps.length) {
                _submitForm(nuevoInitialValues);
            }
        }
    }, []);

    return (
        <React.Fragment>

            {action === 'emitir'
                ?
                <>
                    {isCotizarDone2
                        ? handlerEndCotizacion(finalValues, cotizacionResponse)
                        : null
                    }
                </>

                : <div className={classes.formBox}>

                    <div className={classes.iconCircle}>
                        <img src={white_house_icon} alt="white_car_icon" style={{width: "40px", height: "auto"}}/>
                    </div>
                    <div style={{margin: "24px 0"}}>
                        <ProgressBar activeStep={activeStep} stepTitles={steps}/>
                    </div>

                    <Fragment>
                        {activeStep > 0 ? (
                            <Fragment>
                                {isCotizarDone2
                                    ? handlerEndCotizacion(finalValues, cotizacionResponse)
                                    : null
                                }
                            </Fragment>
                        ) : null}

                        <Formik
                            initialValues={cotizacionRetomada ? nuevoInitialValues : formInitialValues}
                            validationSchema={currentValidationSchema}
                            validateOnBlur={false}
                            onSubmit={_handleSubmit}
                        >
                            {({isSubmitting, errors}) => (
                                <Form id={formId}>
                                    {_renderStepContent(activeStep, cotizacionRetomada, errors)}
                                    <div className={classes.buttons}>
                                        {activeStep !== 0
                                            ? activeStep < 2
                                                ? (
                                                    <Button
                                                        onClick={_handleBack}
                                                        className={classes.backButton}
                                                        disabled={isSubmitting}
                                                        variant="contained"
                                                    >
                                                        Atras
                                                    </Button>
                                                )
                                                : null
                                            : null
                                        }
                                        <div className={classes.buttons}>
                                            <Button
                                                disabled={isSubmitting}
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className={classes.buttonContained}
                                            >
                                                {activeStep > 0 ? "Cotizar" : "Siguiente"}
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                    </Fragment>

                </div>

            }

        </React.Fragment>
    );
}
